import React from 'react';
import './FeatureGrid.css';

const features = [
  {
    icon: './idea-to-blueprint.svg',
    alt: 'Blueprint icon',
    title: 'Idea‑to‑Blueprint',
    description: 'Describe an idea, instantly receive a structured one‑pager.'
  },
  {
    icon: './economy-calculator.svg',
    alt: 'Calculator icon',
    title: 'Economy Calculator',
    description: 'Preview CAC, LTV & break‑even before spending a cent.'
  },
  {
    icon: './reality-check.svg',
    alt: 'Checkmark icon',
    title: 'Reality Check',
    description: 'Quick‑screen your idea & TAM in minutes—zero guesswork.'
  },
  {
    icon: './next-step-navigator.svg',
    alt: 'Compass icon',
    title: 'Next‑Step Navigator',
    description: 'Auto‑generate a prioritised task list from interview to MVP.'
  },
  {
    icon: './competition-snapshot.svg',
    alt: 'Radar icon',
    title: 'Competition Snapshot',
    description: 'Digest competitor, market size & unit‑economy data at a glance.'
  },
  {
    icon: './not-silver-bullet.svg',
    alt: 'Founder control icon',
    title: 'Founder‑First Control',
    description: 'We frame & check ideas—execution and funding stay yours.'
  }
];

export default function FeatureGrid() {
  return (
    <section className="feature-grid" aria-label="Product features">
      {features.map(({ icon, alt, title, description }) => (
        <article key={title} className="grid-item" tabIndex="0">
          <div className="grid-icon">
            <img src={icon} alt={alt} loading="lazy" />
          </div>
          <h4 className="grid-title">{title}</h4>
          <p className="grid-description">✓ {description}</p>
        </article>
      ))}
    </section>
  );
}